import BaseTooltip from 'components/Tooltips/BaseTooltip';
import type { ReactNode } from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import './assets/helpHint.css';

/** The info mark. Keyboard-reachable so the tooltip opens on focus as well. */
const HelpHint = ({ text }: { text: ReactNode }) => (
  <BaseTooltip text={text} placement="top" className="responder-tooltip">
    <span
      className="ms-2 text-info align-middle flood-settings-help-trigger"
      role="img"
      aria-label="help"
      tabIndex={0}
    >
      <FaInfoCircle size={12} />
    </span>
  </BaseTooltip>
);

export default HelpHint;
